import React from 'react';
import { Provider } from 'react-redux';
import { MessageBox } from './components/MessageBox';
import { LoginPasswordProvider } from './context/LoginPassword';
import { MessageBoxProvider } from './context/MessageBox';
import { NotificationProvider } from './context/NotificationContext';
import Routes from './routes';
import store from './store';
import GlobalAppStyle from './styles/GlobalApp.styles';

const App = () => (
  <Provider store={store}>
    <MessageBoxProvider>
      <NotificationProvider>
        <LoginPasswordProvider>
          <GlobalAppStyle />
          <Routes />
          <MessageBox />
        </LoginPasswordProvider>
      </NotificationProvider>
    </MessageBoxProvider>
  </Provider>
);

export default App;
